import adminReducer from "@/components/privacy/admin/ducks/reducer"
import userReducer from "@/components/privacy/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const privacyReducer = combineReducers({
  user: userReducer,
  admin: adminReducer,
})

export default privacyReducer
